import React from 'react'
import ModalWithForm from '../Components/ModalWithForm';
import DemoModal from '../Components/DemoModal';
import Cardrs3 from '../Components/Cardrs3';

const Solutions = () => {
  return (
    <div className='solu-container'>
        <h2 className='hehe'>Solutions</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        
        {/* <ModalWithForm/> */}
        <DemoModal/>
        <Cardrs3/>
        
    </div>
  )
}

export default Solutions;